import React from 'react';

import useTranslateLpc from '@components/common/hooks/useTranslateLpc';
import useWindowSize from '@components/common/hooks/useWindowSize';
import Text from '@components/common/Text/Text';
import { M_DEVICE } from '@components/lpc/Constants';

import css from './Card.module.scss';

type PotTypeSelectionProps = {
    selectedCreationType?: string;
    cardType: string;
    image: string;
    icon?: string;
    selected?: boolean;
    customClass?: string;
    customTitleClass?: string;
    hideImage?: boolean;
};

const Card = ({ cardType, image, icon, selected, hideImage, customClass, customTitleClass }: PotTypeSelectionProps) => {
    const { t } = useTranslateLpc(['lpc-create-pot']);
    const { width } = useWindowSize();

    return (
        <div className={`${css.card} ${selected && css.card__selected} ${customClass || ''}`}>
            {!hideImage && (
                <div
                    className={css.card__image_container}
                    style={{ backgroundImage: `url(/front-static/images/pot/${image})` }}
                />
            )}
            <div className={css.card__text}>
                {width > M_DEVICE && (
                    <Text customClass={css.card__text__hint} variant={'body_02'} color={'black-gray'}>
                        {t(`pot-type-selection.${cardType}.hint`)}
                    </Text>
                )}
                <Text
                    customClass={`${css.card__text__title} ${customTitleClass && customTitleClass}`}
                    variant={'body_02'}
                    color={'black-gray'}
                >
                    {t(`pot-type-selection.${cardType}.title`)}
                </Text>
                <Text customClass={css.card__text__description} variant={'body_02'} color={'black-gray'}>
                    {t(`pot-type-selection.${cardType}.description`)}
                </Text>
            </div>
            {icon && (
                <div className={css.card__icon}>
                    <img src={`/${icon}`} alt={'next'} />
                </div>
            )}
        </div>
    );
};
export default Card;
